import moment from 'moment';

export default function isInPeriod(dateString, period) {
  const periodStart = moment(period.startDate, 'YYYY-MM-DD');
  const periodEnd = moment(period.endDate, 'YYYY-MM-DD');
  const date = moment(dateString, 'YYYY-MM-DD');
  return date.isBetween(periodStart, periodEnd, 'day', '[]');
}
